// AI트래커 산점도 좌표/반지름 투영 순수함수.
// AITrackerContent의 getScreenCoords/getRelativeRadius에서 추출 — 브라우저·React 없이
// 단위테스트 가능하게 하여, 일별 재생 '점 이동 애니메이션'의 투영 로직을 독립 검증한다.
// (동작은 원본과 동일: getScreenCoords는 dims 미확정 시 null, 마진 10 고정)

export const DOT_MIN_RADIUS = 4;
export const DOT_MAX_RADIUS = 14;
export const CHART_MARGIN = { top: 10, right: 10, bottom: 10, left: 10 };

// plotX/plotY(도메인 좌표) → 오버레이 픽셀 좌표. dims(차트 크기) 미확정이면 null.
// y는 위가 +이므로 (yMax - plotY)로 뒤집는다.
export function projectPoint(item, axisRange, dims, margin = CHART_MARGIN) {
  if (!dims || !dims.width || !dims.height) return null;
  const { xMin, xMax, yMin, yMax } = axisRange;
  const plotWidth = dims.width - margin.left - margin.right;
  const plotHeight = dims.height - margin.top - margin.bottom;
  const xRange = (xMax - xMin) || 1;
  const yRange = (yMax - yMin) || 1;
  const x = margin.left + ((item.plotX - xMin) / xRange) * plotWidth;
  const y = margin.top + ((yMax - item.plotY) / yRange) * plotHeight;
  return { x, y };
}

// 값(stability 등) → 점 반지름(minR~maxR로 선형 정규화). min===max면 중간 크기.
export function relativeRadius(value, sizeRange, minR = DOT_MIN_RADIUS, maxR = DOT_MAX_RADIUS) {
  const { min, max } = sizeRange;
  if (max === min) return (minR + maxR) / 2;
  const normalized = (value - min) / (max - min); // 0~1 (값이 클수록 큼)
  return minR + normalized * (maxR - minR);
}
